export function toHtmlElementOrNull(element: null | Text | Element): HTMLElement | null {
    if (element instanceof HTMLElement) {
        return element;
    }
    return null;
}

export function* iterateOverHTMLCollection(collection: HTMLCollection): Iterable<Element> {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < collection.length; i++) {
        const item = collection[i];
        if (item != undefined) {
            yield item;
        }
    }
}

export function isElementInViewPort(element: Element): boolean {
    const rect = element.getBoundingClientRect();
    return (
        (rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
        (rect.bottom >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) ||
        (rect.top < 0 && rect.bottom > (window.innerHeight || document.documentElement.clientHeight))
    );
}
